import { dispatcher, ingenuity, SpineBase } from "@quest/base-core";
import { BigWinControllerFg, SlotConstantsBehavior, SlotEventConstantsBehavior, SoundConstant } from "@quest/murka-games-behavior-panther/dist";
import { spineConstants } from "../Constants/gameConstants";
import { Linear } from "@quest/pixi-bridge";
// import { GameParserModel } from "../Platform/GameParserModel";



export class BigWinControllerFgGame extends BigWinControllerFg {
    protected freegameBigWinDesktopBg: string;
    protected fgLoopSpineBg: SpineBase;
    protected fgPortraitSpineBg: SpineBase;
    constructor(view: any, model: any) {
        super(view, model);
        this.freegameBigWinDesktopBg = spineConstants.FG_BIG_WIN_DESKTOP_BG;
    }
    protected initializeFSBigWinElements(): void {
        super.initializeFSBigWinElements();
        this.fgLoopSpineBg = this.view.getSpineById(this.freegameBigWinDesktopBg);
    }
    protected playFgSpineInLoop(): void {
        super.playFgSpineInLoop();
        this.fgLoopSpineBg = this.view.getSpineById(this.freegameBigWinDesktopBg);
        this.fgLoopSpineBg.setPause(false);
        this.fgLoopSpineBg.visible = true;
        this.fgLoopSpineBg.playAnim(spineConstants.FG_BIG_WIN_DESKTOP_START_BG, false);
        this.fgLoopSpineBg.onComplete.addOnce(() => {
            this.fgLoopSpineBg.playAnim(spineConstants.FG_BIG_WIN_DESKTOP_LOOP_BG, true);
        }, this);
    }
    protected stopFgSpineInLoop(): void {
        super.stopFgSpineInLoop();
        this.fgLoopSpineBg = this.view.getSpineById(this.freegameBigWinDesktopBg);
        this.fgLoopSpineBg.playAnim(spineConstants.FG_BIG_WIN_DESKTOP_END_BG, false);
        this.fgLoopSpineBg.onComplete.addOnce(() => {
            this.fgLoopSpineBg.visible = false;
            this.fgLoopSpineBg.setPause(true);
            this.fgLoopSpineBg.onComplete.dispose();
        }, this);
    }

    protected showFSBigWinTickup(): void {
        this.freeSpinBigWinContainer.visible = true;
        this.freeSpinBigWinContainer.x = this.freeSpinBigWinContainer.json.initialX;
        const moveTween = ingenuity.currentGame.add.tween(this.freeSpinBigWinContainer).to({ x: this.freeSpinBigWinContainer.json.finalX }, SlotConstantsBehavior.TICKUP_MOVE_IN_LEFT_DURATION, Linear.None, true, 0, 0, false);
        moveTween.onComplete.addOnce(() => {
            this.startFSBigWinTickup();
            moveTween.stop();
            ingenuity.currentGame.tweens.remove(moveTween);
        }, this);
    }
    startFSBigWinTickup() {
        dispatcher.fireEvent(SlotEventConstantsBehavior.ENABLE_STAGE_CLICK_FG);
        this.currentWinAmountTickUpFg = this.model.getCurrentWinAmt() 
        // + (ingenuity.parserModel as GameParserModel).getclueRevealedWinAmt() + (ingenuity.parserModel as GameParserModel).getMoneyHuntingTotalWin();
        dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, { id: SoundConstant.WIN_SOUND_FG_3, vol: 1, loop: false, key: SlotConstantsBehavior.SOUND_LIST_POSTLOAD });
        this.freeSpinBigWinMeter.visible = true;
        this.freeSpinBigWinMeter.startTick(this.currentWinAmountTickUpFg, true, false, SlotConstantsBehavior.WINTICKUP_FG_3, true, this.freeSpinBigWinPresentationComplete.bind(this));
    }
    /**
     * Called when Fg stage click
     */
    protected stopFSBigWinAndTicker(): void {
        this.freeSpinBigWinMeter.stopTick(false, true, true);
        this.freeSpinBigWinMeter.setCurrencyFormattedValue(String(this.currentWinAmountTickUpFg));
    }
    protected onForcestopFSBigWinAndTicker(): void {
        this.freeSpinBigWinMeter.stopTick(false, true, true);
        this.freeSpinBigWinMeter.setCurrencyFormattedValue(String(this.currentWinAmountTickUpFg));
        this.freeSpinBigWinPresentationComplete();
    }

    // protrait 


    protected initializePortraitComponent() {
        super.initializePortraitComponent();
        this.fgPortraitSpineBg = this.view.getSpineById("freebigwin_port_bg");
    }
    protected playFgPortraitSpineInLoop(): void {
        super.playFgPortraitSpineInLoop();
        this.fgPortraitSpineBg.setPause(false);
        this.fgPortraitSpineBg.visible = true;
        this.fgPortraitSpineBg.playAnim("big_win_portrait_in_bg", false);
        this.fgPortraitSpineBg.onComplete.addOnce(() => {
            this.fgPortraitSpineBg.playAnim("big_win_portrait_loop_bg", true);
        }, this);
    }
    protected stopFgPortraitSpineInLoop(): void {
        super.stopFgPortraitSpineInLoop();
        this.fgPortraitSpineBg.playAnim("big_win_portrait_out_bg", false);
        this.fgPortraitSpineBg.onComplete.addOnce(() => {
            this.fgPortraitSpineBg.visible = false;
            this.fgPortraitSpineBg.setPause(true);
            this.fgPortraitSpineBg.onComplete.dispose();
        }, this);
    }
}